import script from "./UContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./UContent.vue?vue&type=script&setup=true&lang=ts"

import "./UContent.vue?vue&type=style&index=0&id=61a51822&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a51822"]])

export default __exports__